<template>
  <Button class="!px-2" size="sm" variant="tertiary">
    <ArrowDownTrayIcon v-if="type === 'positions'" class="h-[18px] w-[18px]" />
    <ArrowDownTrayIcon v-if="type === 'shipments'" class="h-[18px] w-[18px]" />
    <FlagIcon v-if="type === 'stops'" class="h-[18px] w-[18px]" />
  </Button>
</template>

<script setup>
defineProps({
  type: {
    type: String,
    required: true,
  },
});
</script>
